import { useQuery } from "@tanstack/vue-query";

import { client } from "@/api";

export const useAgentMemories = () => useQuery({
	queryKey: ["agent-memories"],
	queryFn: async () => {
		const { data } = await client.api.v1.agents.memories.get();
		return data?.memories ?? [];
	},
	refetchOnMount: true,
});